module.exports = __webpack_public_path__ + "static/media/ts6tj128.61d10870.png";